import { render, staticRenderFns } from "./EventCreatePopup.vue?vue&type=template&id=167f537a&"
import script from "./EventCreatePopup.vue?vue&type=script&lang=js&"
export * from "./EventCreatePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports